import type { ReactNode } from 'react';

import { InfoTooltip } from '@ui/uikit/components/common/Tooltip';
import type { DataQaInterface } from '@utilities/helpers/types';

import { Typography } from '../Typography';
import styles from './PriceDetailItem.module.scss';

type Props = DataQaInterface & {
  description: ReactNode;
  value: ReactNode;
  tooltip?: string;
  isStrong?: boolean;
  isLoading?: boolean;
};

export const PriceDetailItem = ({
  description,
  value,
  tooltip,
  isStrong,
  isLoading,
  dataQa,
}: Props) => {
  return (
    <div className={styles.wrapper}>
      <Typography
        noWrap
        variant={isStrong ? 'caption-s-strong' : 'caption-s'}
        color={isStrong ? 'primary' : 'tertiary'}
      >
        {description}
      </Typography>
      <div className={styles.divider} />
      <div className={styles.value} data-qa={dataQa}>
        {isLoading ? (
          <span className="skeleton-text h-3 w-16" />
        ) : (
          <Typography noWrap variant="caption-s-strong" color="primary">
            {value}
          </Typography>
        )}
        {tooltip ? <InfoTooltip message={tooltip} /> : null}
      </div>
    </div>
  );
};
